<template>

    <LayoutDefault>

        <section class="fuid-resu__loading">

            <section class="fuid-resu__tpvcontainer">

                <b-row>

                    <b-col cols="12" class="fuid-form-to-render">

                        <h4 class="fuid-resu-tit">{{ $t('paymentok.titiban') }}</h4>

                    </b-col>

                </b-row>

                <b-row>

                    <b-col cols="12" class="fuid-resu__tpvok">

                        <p class="text-center">{{ $t('paymentok.amount') }}: {{ getMatriculaTotal }} {{ $t('payment.euro') }}</p>

                    </b-col>
                
                </b-row>

                <b-row>

                    <b-col cols="12" class="d-flex justify-content-center align-items-center fuid-form__actions">

                        <button class="fuid-button fuid-button-step align-items-center" @click.prevent="toLogin()">

                            {{ $t("login.out") }}

                        </button>

                    </b-col>

                </b-row>

            </section>

        </section>

    </LayoutDefault>

</template>

<script>

    import { mapGetters } from 'vuex'
    import LayoutDefault from '@/components/layouts/LayoutDefault'

    export default {

        data() {
            
            return {
                
            }

        },

        methods: {
            
            /*
            * Router to login
            *
            */
           toLogin() {

               this.$router.push(`/${this.$i18n.locale}`)

           }

        },

        mounted() {

            localStorage.removeItem('logged')

        },

        computed: {

            ...mapGetters('Matricula', ['getMatriculaTotal']),

        },

        components: {

            LayoutDefault,
            //errorFromServer

        }
        
    }
    
</script>